<template>
  <div>
    <div>
      Device ID:<b>{{ chooseItem.device_id.substring(7) }}</b>
    </div>
    <el-row>
      <el-table :data="list" empty-text="No record!" height="400px" border stripe>
        <el-table-column label="Date" prop="date" width="200"></el-table-column>
        <el-table-column label="files">
          <template slot-scope="scope">
            <template v-for="item of scope.row.list">
              <div><a :href="item.url.replace(/^http:/, 'https:')" :download="item.name">{{item.name}}</a></div>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row align="right">
      <el-col align="right">
        <el-button size="small" @click="$emit('close')">back</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "DeviceLog",
  props: {
    chooseItem: Object,
    close: Function,
  },
  data() {
    return {
      list: [],
    };
  },
  created() {
    setTimeout(() => {
      this.getData();
    }, 200);
  },
  methods: {
    getData() {
      let loading = this.$util.loading();
      this.$api.rootV1.post(
        "/web/device/getdevicelog",
        { device_id: this.chooseItem.device_id },
        (res) => {
          this.list = res.data;
          loading.close();
        },
        () => {
          loading.close();
        }
      );
    }
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/main/device/DeviceLog.vue